import { render, staticRenderFns } from "./vueVideoPlayer.vue?vue&type=template&id=9d2f2728&"
import script from "./vueVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./vueVideoPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports